import { mustBeAdmin } from "../util/auth";

const Csv = () => import("../components/content/quickpay/uploadcsv");
const BankCode = () => import("../components/content/quickpay/bankCode.vue");

const QuickpayWallet = () =>
  import("../components/content/quickpay/quickPayWallet");
const OnetimeUpload = () =>
  import("../components/content/quickpay/onetimeUpload");
const OnetimePreview = () =>
  import("../components/content/quickpay/onetimePreview.vue");
const OnetimeWallet = () =>
  import("../components/content/quickpay/onetimeWallet.vue");


export const uploadCsvRoute = {
  path: "/upload-csv",
  component: Csv,
  // beforeEnter: ifAuthenticated
  beforeEnter: mustBeAdmin
};

export const onetimeUploadRoute = {
  path: "/onetime-upload",
  component: OnetimeUpload,
  // beforeEnter: ifAuthenticated
  beforeEnter: mustBeAdmin
};

export const onetimePreviewRoute = {
  path: "/onetime-preview",
  component: OnetimePreview,
  // beforeEnter: ifAuthenticated
  beforeEnter: mustBeAdmin
};

export const QuickPayWalletRoute = {
  path: "/quickpay-wallet",
  component: QuickpayWallet,
  // beforeEnter: ifAuthenticated
  beforeEnter: mustBeAdmin
};

export const onetimeWalletRoute = {
  path: "/onetime-wallet",
  component: OnetimeWallet,
  // beforeEnter: ifAuthenticated
  beforeEnter: mustBeAdmin
};

export const bankCodeRoute = {
  path: "/bank-codes",
  component: BankCode
};